import React, { useState, useEffect } from 'react';
import { Checkbox } from '@fluentui/react';

const MasterDataNotificationEvents = ({notificationEvents, onCheckedEvents}) => {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        onCheckedEvents(events);
    }, [events]);
    
    useEffect(() => {
        setEvents(notificationEvents.map(evt => ({ siteEvent: evt.siteEvent })));
    }, []);


    const defaultEvents = [
        {
            id: 0,
            label: 'Site is created',
            siteEvent: 'New'
        }, 
        {
            id: 5,
            label: 'Site is deleted/archived',
            siteEvent: 'Deleted'
        }, 
        {
            id: 6,
            label: 'Site is expired',
            siteEvent: 'Expired'
        },
        {
            id: 22,
            label: 'Site is disabled',
            siteEvent: 'Disabled'
        },
        {
            id: 35,
            label: 'Site is deleted outside Provisioner',
            siteEvent: 'DeletedOutside'
        }
    ]

    const items = defaultEvents.map(x => 
        <div key={x.id} style={childStyles}>
            <Checkbox label={x.label} onChange={(v) => _onChange(v, x.siteEvent)} defaultChecked={notificationEvents.some(v => v.siteEvent === x.siteEvent)}/>
        </div>
    )

    const _onChange = (ev, value) => {
        const isChecked = ev.target.checked;

        setEvents(prevState => {
            if (isChecked) {
              return [...prevState, { siteEvent: value }];
            } else {
              return prevState.filter(event => event.siteEvent !== value);
            }
          });
    }

    return (
        <div>
            <div style={headerStyles}>Send notifications when:</div>
            <div style={containerStyles}>
                {items}
            </div>
        </div>
    );
}

const headerStyles = {
    margin: '10px 0 10px 0'
}
const containerStyles = {
    display: 'flex',
    flexDirection: 'row',
    margin: '10px 20px 20px 0',
}

const childStyles = {
    paddingRight: '10px'
}

export default MasterDataNotificationEvents;


// WEBPACK FOOTER //
// ./src/components/Settings/MasterDataNotificationEvents.js